import React from 'react';

import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Switch from '@mui/material/Switch';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import FormControlLabel from '@mui/material/FormControlLabel';

import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import SvgIcon from "@mui/material/SvgIcon";
import Icon from "@mui/material/Icon";
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

// import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

import CircularProgress from '@mui/material/CircularProgress';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import TextField from '@mui/material/TextField';

import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import SheetMusicPlayer from './SheetMusicPlayer';

import Alert from '@mui/material/Alert';

import domtoimage from 'dom-to-image';

import ScoreDisplayer from "../ScoreDisplayer.js"

import { jsPDF } from "jspdf";

import TextManager from '../TextManager';

// import Switch from '@mui/material/Switch';

const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297;
const A4_ASPECT_RATIO = 1.414;

export default class PrintingPage extends React.Component {
	state = {
		debugRectangles: null,
		showProcessingDialog: false,
	}

	scale = 2;

	getExportTitle() {
		let title = "export";
		try {
			title = ScoreDisplayer.singleton.osmd.graphic.title.TextLines[0].text;
		} catch (exception) {
		}

		return title;
	}

	getPageBreakPositions(pageAspectRatio) { // including the 0
		const osmd = ScoreDisplayer.singleton.osmd;
		const osmdExtension = ScoreDisplayer.singleton.osmdExtension;
		const musicSystems = osmdExtension.findAllMusicSystems();

		const width = ScoreDisplayer.singleton.osmd.container.getBoundingClientRect().width;
		const maxHeight = pageAspectRatio * width;

		const musicSystemBreakPositions = osmdExtension.findMusicSystemBreakPosition();

		let heightCount = 0;
		let lastPosition = 0;

		const pageBreakPositions = [0];
		// for (const [i, breakPosition] of musicSystemBreakPositions.entries()) {
		// 	console.log(i, breakPosition)
		// }

		for (const [i, breakPosition] of musicSystemBreakPositions.entries()) {
			if (breakPosition - lastPosition < maxHeight) {
				heightCount = breakPosition - lastPosition;
			} else {
				lastPosition = musicSystemBreakPositions[i - 1];
				heightCount = 0;

				pageBreakPositions.push(lastPosition);
			}
		}

		pageBreakPositions.push(musicSystemBreakPositions[musicSystemBreakPositions.length - 1]);

		return pageBreakPositions;
	}

	getClippedImageCanvas(image, x, y, width, height) {
		var canvas = document.createElement("canvas"),
			ctx = canvas.getContext("2d");

		canvas.width = width;
		canvas.height = height;

		ctx.drawImage(image, x, y, width, height, 0, 0, width, height);

		return canvas;
	}

	convertScoreImageToMultiPagePdf(imageUrl, filename) {
		const singlePageScoreImage = new Image();
		singlePageScoreImage.src = imageUrl;

		singlePageScoreImage.onload = () => {

			var pageBreakPositions = this.getPageBreakPositions(A4_ASPECT_RATIO);

			var doc = new jsPDF({
				unit: "mm",
			});

			const width = ScoreDisplayer.singleton.osmd.container.getBoundingClientRect().width * this.scale;

			for (const [i, pageBreakPosition] of pageBreakPositions.entries()) {
				if (i < pageBreakPositions.length - 1) {
					const nextPosition = pageBreakPositions[i + 1];
					const height = (nextPosition - pageBreakPosition) * this.scale;
					const y = pageBreakPosition * this.scale

					let canvas = this.getClippedImageCanvas(singlePageScoreImage, 0, y, width, height);

					let splitImageUrl = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

					doc.addImage(splitImageUrl, 'PNG', 0, 0, A4_WIDTH_MM, (A4_WIDTH_MM / width) * height)

					if (i < pageBreakPositions.length - 2) {
						doc.addPage();
					}
				}
			}

			doc.save(filename + ".pdf");

		};
	}

	exportScorePdf(domElement, filename) {

		const f = () => domtoimage.toPng(
			domElement,
			{
				filter: (node) => {
					return node.id != "scoreRangeSelector" && node.tagName != "IMG";
				},
				width: ScoreDisplayer.singleton.osmd.container.getBoundingClientRect().width * this.scale,
				height: ScoreDisplayer.singleton.osmd.container.getBoundingClientRect().height * this.scale,
				style: {
					transform: 'scale(' + this.scale + ')',
					transformOrigin: 'top left',
					overflow: "hidden" // hide scroll bar
				},
				bgcolor: "white"
			}
		).then((dataUrl) => {
			this.convertScoreImageToMultiPagePdf(dataUrl, filename);

			this.setState({showProcessingDialog: false});

		}).catch((error) => {
			console.error('oops, something went wrong!', error);

			this.setState({showProcessingDialog: false});
		});

		this.setState({showProcessingDialog: true}, () => {
			setTimeout(f, 200);

			// setTimeout(()=>{
			// 	this.setState({showProcessingDialog: false});
			// }, 5000);
		});
	}

	async saveArrayBufferAsFile(arrayBuffer, fileName , fileType) {
		this.setState({showProcessingDialog: true}, async () => {
				await this._saveArrayBufferAsFile(arrayBuffer, fileName , fileType);
				this.setState({showProcessingDialog: false});
			}
		);
	}

	async _saveArrayBufferAsFile(arrayBuffer, fileName , fileType) {
		return new Promise((resolve, reject) => {
			// const dataView = new DataView(plaintext);
			const blob = new Blob([arrayBuffer], { type: fileType });

			if (navigator.msSaveBlob) {
				navigator.msSaveBlob(blob, fileName);
				return resolve();
			} else if (/iPhone|fxios/i.test(navigator.userAgent)) {
				// This method is much slower but createObjectURL
				// is buggy on iOS
				const reader = new FileReader();
				reader.addEventListener('loadend', () => {
					if (reader.error) {
					return reject(reader.error);
					}
					if (reader.result) {
					const a = document.createElement('a');
					// @ts-ignore
					a.href = reader.result;
					a.download = fileName;
					document.body.appendChild(a);
					a.click();
					}
					resolve();
				});
				reader.readAsDataURL(blob);
			} else {
				const downloadUrl = URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = downloadUrl;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();
				URL.revokeObjectURL(downloadUrl);
				setTimeout(resolve, 100);
			}
		});
	}

	render() {

		return (

			<div className="PopupPage">
				{/*<CloseIcon sx={{float:"right", left:"100px"}}/>*/}

				{this.state.debugRectangles}

				<div className="PageTitle">{TextManager.getText("export")}</div>

				<List className="PageList">

					<ListItem>
						<ListItemText primary={TextManager.getText("midi")} />
						<Button variant="contained" onClick={()=> this.saveArrayBufferAsFile(SheetMusicPlayer.singleton.state.midi, this.getExportTitle() + ".mid", "audio/sp-midi")}>
							{TextManager.getText("export")}
						</Button>
					</ListItem>

					<ListItem>
						<ListItemText primary={TextManager.getText("music_xml")} />
						<Button variant="contained" onClick={()=> this.saveArrayBufferAsFile(SheetMusicPlayer.singleton.state.mxl, this.getExportTitle() + ".mxl", "application/vnd.recordare.musicxml+xml")}>
							{TextManager.getText("export")}
						</Button>
					</ListItem>

					<ListItem>
						<ListItemText primary={TextManager.getText("pdf_with_annotation")} />
						<Button variant="contained" onClick={(e) => {
							const element = document.getElementById("MainScrollBox");

							this.exportScorePdf(element, this.getExportTitle() + " (annotated)");
						}}>
							{TextManager.getText("export")}
						</Button>
					</ListItem>

					<ListItem>
						<ListItemText primary={TextManager.getText("pdf_without_annotation")} />
						<Button variant="contained" onClick={(e) => {
							const element = ScoreDisplayer.singleton.osmd.container;

							this.exportScorePdf(element, this.getExportTitle());
						}}>
							{TextManager.getText("export")}
						</Button>
					</ListItem>
				</List>

				<Stack spacing={2} direction="row" justifyContent="center">
					<Button onClick={this.props.close} variant="contained">
						{TextManager.getText("confirm")}
					</Button>
				</Stack>

				<Dialog open={this.state.showProcessingDialog} >
					<Box sx={{
						margin: "50px 50px",
					}}>
						<Stack spacing={1} direction="column" justifyContent="center" alignItems="center">
							<CircularProgress disableShrink/>
							<Typography>{TextManager.getText("processing")}</Typography>
						</Stack>
					</Box>
				</Dialog>
			</div>
		);
	}
}